var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgProfiletwo = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3191 23.24C18.2591 23.24 18.2191 23.24 18.1591 23.24C18.0591 23.22 17.9191 23.22 17.7991 23.24C11.9991 23.06 7.61914 18.5 7.61914 12.88C7.61914 7.16 12.2791 2.5 17.9991 2.5C23.7191 2.5 28.3791 7.16 28.3791 12.88C28.3591 18.5 23.9591 23.06 18.3791 23.24C18.3591 23.24 18.3391 23.24 18.3191 23.24ZM17.9991 5.5C13.9391 5.5 10.6191 8.82 10.6191 12.88C10.6191 16.88 13.7391 20.1 17.7191 20.24C17.8391 20.22 18.0991 20.22 18.3591 20.24C22.2791 20.06 25.3591 16.84 25.3791 12.88C25.3791 8.82 22.0591 5.5 17.9991 5.5Z",
    fill: "url(#paint0_linear_2004_138)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3191 23.24C18.2591 23.24 18.2191 23.24 18.1591 23.24C18.0591 23.22 17.9191 23.22 17.7991 23.24C11.9991 23.06 7.61914 18.5 7.61914 12.88C7.61914 7.16 12.2791 2.5 17.9991 2.5C23.7191 2.5 28.3791 7.16 28.3791 12.88C28.3591 18.5 23.9591 23.06 18.3791 23.24C18.3591 23.24 18.3391 23.24 18.3191 23.24ZM17.9991 5.5C13.9391 5.5 10.6191 8.82 10.6191 12.88C10.6191 16.88 13.7391 20.1 17.7191 20.24C17.8391 20.22 18.0991 20.22 18.3591 20.24C22.2791 20.06 25.3591 16.84 25.3791 12.88C25.3791 8.82 22.0591 5.5 17.9991 5.5Z",
    fill: "url(#paint1_linear_2004_138)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0792 23.5C33.0192 23.5 32.9592 23.5 32.8992 23.48C32.0792 23.56 31.2392 22.98 31.1592 22.16C31.0792 21.34 31.5792 20.6 32.3992 20.5C32.6392 20.48 32.8992 20.48 33.1192 20.48C36.0392 20.32 38.3192 17.92 38.3192 14.98C38.3192 11.94 35.8592 9.48 32.8192 9.48C31.9992 9.5 31.3192 8.82 31.3192 8C31.3192 7.18 31.9992 6.5 32.8192 6.5C37.4992 6.5 41.3192 10.32 41.3192 15C41.3192 19.6 37.7192 23.32 33.1392 23.5C33.1192 23.5 33.0992 23.5 33.0792 23.5Z",
    fill: "url(#paint2_linear_2004_138)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0792 23.5C33.0192 23.5 32.9592 23.5 32.8992 23.48C32.0792 23.56 31.2392 22.98 31.1592 22.16C31.0792 21.34 31.5792 20.6 32.3992 20.5C32.6392 20.48 32.8992 20.48 33.1192 20.48C36.0392 20.32 38.3192 17.92 38.3192 14.98C38.3192 11.94 35.8592 9.48 32.8192 9.48C31.9992 9.5 31.3192 8.82 31.3192 8C31.3192 7.18 31.9992 6.5 32.8192 6.5C37.4992 6.5 41.3192 10.32 41.3192 15C41.3192 19.6 37.7192 23.32 33.1392 23.5C33.1192 23.5 33.0992 23.5 33.0792 23.5Z",
    fill: "url(#paint3_linear_2004_138)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3392 45.1C14.4192 45.1 10.4792 44.1 7.49922 42.1C4.71922 40.26 3.19922 37.74 3.19922 35C3.19922 32.26 4.71922 29.72 7.49922 27.86C13.4992 23.88 23.2192 23.88 29.1792 27.86C31.9392 29.7 33.4792 32.22 33.4792 34.96C33.4792 37.7 31.9592 40.24 29.1792 42.1C26.1792 44.1 22.2592 45.1 18.3392 45.1ZM9.15922 30.38C7.23922 31.66 6.19922 33.3 6.19922 35.02C6.19922 36.72 7.25922 38.36 9.15922 39.62C14.1392 42.96 22.5392 42.96 27.5192 39.62C29.4392 38.34 30.4792 36.7 30.4792 34.98C30.4792 33.28 29.4192 31.64 27.5192 30.38C22.5392 27.06 14.1392 27.06 9.15922 30.38Z",
    fill: "#455CC7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6791 41.5C35.9791 41.5 35.3591 41.02 35.2191 40.3C35.0591 39.48 35.5791 38.7 36.3791 38.52C37.6391 38.26 38.7991 37.76 39.6991 37.06C40.8391 36.2 41.4591 35.12 41.4591 33.98C41.4591 32.84 40.8391 31.76 39.7191 30.92C38.8391 30.24 37.7391 29.76 36.4391 29.46C35.6391 29.28 35.1191 28.48 35.2991 27.66C35.4791 26.86 36.2791 26.34 37.0991 26.52C38.8191 26.9 40.3191 27.58 41.5391 28.52C43.3991 29.92 44.4591 31.9 44.4591 33.98C44.4591 36.06 43.3791 38.04 41.5191 39.46C40.2791 40.42 38.7191 41.12 36.9991 41.46C36.8791 41.5 36.7791 41.5 36.6791 41.5Z",
    fill: "#455CC7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2004_138",
    x1: 7.76023,
    y1: 2.5,
    x2: 7.76023,
    y2: 22.9581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3758CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3758CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2004_138",
    x1: 17.9991,
    y1: 2.5,
    x2: 17.9991,
    y2: 23.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3758CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2004_138",
    x1: 31.22,
    y1: 6.5,
    x2: 31.22,
    y2: 23.2689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3758CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3758CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2004_138",
    x1: 36.2351,
    y1: 6.5,
    x2: 36.2351,
    y2: 23.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3758CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProfiletwo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/profiletwo.a50b0da7.svg";
export { ForwardRef as ReactComponent };